<template>
<v-container fluid class="fill-height pb50 pt50">

  <v-row align="center" justify="center">

    <v-col cols="12" sm="10" md="7" lg="6" xl="5">
      <v-card>


        <v-card-title class="secondary white--text">
          <v-icon dark>fa-wallet</v-icon>
          <v-spacer></v-spacer>
          Wallet
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.wallet['General'])">
            <v-icon>fa-question</v-icon>
          </v-btn>

          <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
        </v-card-title>


        <v-card-actions class="pa-0" v-if="error">
          <v-col cols="12" class="pa-0 text-center">
            <v-alert type="error" class="mb-0" tile>
              {{error}}
            </v-alert>
          </v-col>
        </v-card-actions>


        <v-card-actions class="clicky" @click="show_more=!show_more">
          <v-col cols="6">
            <h4>Advanced Settings</h4>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn icon>
              <v-icon v-if="!show_more">fa-chevron-down</v-icon>
              <v-icon v-if="show_more">fa-minus</v-icon>
            </v-btn>
          </v-col>
        </v-card-actions>
        <v-divider></v-divider>
        <v-expand-transition>
          <div class="" v-show="show_more">
            <v-container fluid class="secondary lighten-1">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field dark shaded label="Name" clearable hide-details :rules="[rules.required]" v-model="account.name" @change="modified=true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" v-if="account.phone">
                  <v-text-field dark shaded :value="account.phone" label="Phone Number" v-mask="'(###) ###-####'" type="tel" clearable hide-details readonly></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete dark shaded :items="countries" label="Country" v-model="account.country" @change="modified=true" hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field dark shaded v-model="account.state" @change="modified=true" label="State / Province" clearable hide-details></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4">
                  <v-text-field dark shaded v-model="account.zip_code" @change="modified=true" label="Zip / Postal code" clearable hide-details></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field dark shaded v-model="account.address" @change="modified=true" label="Address line 1" hint="Street address, P.O box, company name" clearable persistent-hint></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field dark shaded v-model="account.address_ext" @change="modified=true" label="Address line 2" hint="Apartment, suite, unit, building, floor etc" clearable persistent-hint></v-text-field>
                </v-col>


                <v-col cols="12" sm="12">
                  <v-text-field dark shaded label="Email" hide-details :value="account.email" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-checkbox label="Email Notifications" hide-details dark :true-value="1" :false-value="0" v-model="account.email_notifications" @change="modified=true" color="primary"></v-checkbox>
                </v-col>

                <v-col cols="12" sm="12" class="text-center">
                  <div class="" v-if="modified && show_more">
                    <v-btn dark color="green" @click="save" :loading="loading">Save</v-btn>
                  </div>
                  <div>
                    <v-btn text color="error" @click="confirmDeleteAccount">Delete account</v-btn>
                  </div>
                </v-col>

              </v-row>
            </v-container>
          </div>

        </v-expand-transition>
        <v-container fluid class="pb-0 ">
          <v-row class="py-0">
            <v-col cols="12" sm="12" class="pb-0 text-center">
              <div class="mb-1" v-if="!account.paypal_link">
                <h5>You can find your paypal link <a href="https://www.paypal.me" target="_blank">here</a></h5>
              </div>
              <v-form ref="paypal_link-form" lazy-validation onSubmit="return false;">
                <v-text-field :rules="[rules.paypal_link]" outlined label="Your paypal link" prepend-inner-icon="fab fa-paypal" clearable v-model="account.paypal_link" @change="modified=true"></v-text-field>
              </v-form>
            </v-col>

            <v-col cols="12" sm="12" class="text-center" v-if="modified && !show_more">
              <div class="">
                <v-btn dark color="green" @click="save" :loading="loading">Save</v-btn>
              </div>
            </v-col>

          </v-row>
        </v-container>


        <v-container fluid :class="`green white--text ${$store.getters['wallet/canRequestPayment'] ? 'green-gradient' : 'blue-gradient'}`">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="12" class="text-center">
              <v-icon dark class="mb-2" style="font-size:60px">fas fa-hand-holding-usd</v-icon>
              <h2>Payout available</h2>
            </v-col>
            <v-col cols="12" sm="5" lg="4">
              <v-text-field dark filled label="Amount from publishing" prepend-inner-icon="fa-dollar-sign" hide-details readonly :value="$store.getters['wallet/projectAmount']"></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" lg="4">
              <v-text-field dark filled label="Amount from support" prepend-inner-icon="fa-dollar-sign" hide-details readonly :value="$store.getters['wallet/supportAmount']"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center" cols="12">
              <v-btn @click="requestPayment" class="primary" :disabled="!$store.getters['wallet/canRequestPayment']" :loading="loading">Request payment</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!--
        <v-container class="pa-0" v-if="$store.state.app.display !=='xs' && $store.state.app.display !== 'sm'">
          <v-row class="pa-0">
            <v-col cols="12" class="py-0">
              <v-simple-table v-if="$store.getters['wallet/invoices'].length">
                <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Payments</th>
                <th class="text-left"></th>
                <th class="text-left"></th>
                <th class="text-right"></th>
                <th class="text-right">  <h3>${{$store.getters['wallet/invoiceTotal'] }}</h3></th>
              </tr>
            </thead>
            <invoice v-for="(invoice,i) in $store.getters['wallet/invoices']" :invoice="invoice" :key="i"></invoice>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
        !-->

        <v-container class="pb-0" v-if="$store.getters['wallet/invoices'].length">
          <v-row>
            <v-col cols="6">
              <h4>Payments</h4>
            </v-col>
            <v-col cols="6" class="text-right">
              <h4 class="green--text">${{$store.getters['wallet/invoiceTotal'] }}</h4>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-for="(invoice,i) in $store.getters['wallet/invoices']">
            <invoice  :invoice="invoice" :key="i"></invoice>
            <v-divider v-if="i < $store.getters['wallet/invoices'].length - 1" :key="'d'+i"></v-divider>
          </template>
        </v-container>

      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import invoice from "@/components/wallet/invoice"
import countries from "@/assets/countries.json";

import {
  mask
} from 'vue-the-mask'


export default {
  name: "",
  components: {
    invoice
  },
  data: () => ({
    show_more: false,
    update_account: {
      name: ''
    },
    modified: false,
    error: null,
    loading: false,
    countries: countries,
    headers: [{
        value: 'data-table-expand'
      },
      {
        text: 'Date',
        align: 'left',
        sortable: true,
        value: 'date_added',
      },
      {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'status',
      },
      {
        text: 'Date',
        align: 'right',
        sortable: true,
        value: 'amount',
      },
    ]
  }),
  watch: {

  },
  computed: {
    account: function() {
      return this.$store.state.account.account || {}
    },
    rules: function() {
      return { ...this.$helpers.rules,
        paypal_link: v => {
          if (!v) {
            return false
          }
          if (v.includes('paypal.me')) {
            return false
          } else {
            return "Invalid paypal link"
          }

        }
      }
    }
  },
  created() {
    this.loadWallet()
  },
  methods: {
    confirmDeleteAccount: async function() {
      if (!confirm("Are you sure you want to delete your account ?")) {
        return
      }
      this.$store.dispatch('account/delete')
    },
    async save() {
      if (!this.$refs['paypal_link-form'].validate()) {
        return
      }
      this.updateAccount({
        paypal_link: this.account.paypal_link,
        email_notifications: this.account.email_notifications,
        name: this.account.name,
        country: this.account.country,
        state: this.account.state,
        zip_code: this.account.zip_code,
        address: this.account.address,
        address_ext: this.account.address_ext
      })
    },
    updateAccount: async function(options) {
      this.loading = true
      try {
        await this.$store.dispatch('account/update', options)
        this.modified = false;
        this.error = ''
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false
    },
    requestPayment: async function() {
      this.loading = true
      try {
        await this.$store.dispatch('wallet/requestPayment')
        this.error = ''
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false
    },
    loadWallet: async function() {
      this.loading = true
      try {
        await this.$store.dispatch('wallet/load')
        this.error = ''
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        //this.scrollToSave()
        next(false)
      }
    } else {
      next()
    }
  },
  directives: {
    mask,
  }
}
</script>
<style lang="scss" scoped>
.green-gradient {
    background: #11998e;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #38ef7d, #11998e);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #38ef7d, #11998e);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.red-gradient {
    background: #e53935;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #e35d5b, #e53935);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #e35d5b, #e53935);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.blue-gradient {
    background: #00c6ff;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #0072ff, #00c6ff);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #0072ff, #00c6ff);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>
